<img src="{{flagFilePath}}" class="lang" (click)="onClick()">
